/* eslint-disable */

export const onCreateDocument = /* GraphQL */ `
  subscription OnCreateDocument {
    onCreateDocument {
      id
      associationId
      title
      content
      type
      createdAt
      updatedAt
      owner
      files {
        items {
          id
          file {
            bucket
            region
            key
          }
          title
          createdAt
        }
        nextToken
      }
    }
  }
`
export const onCreateDocumentPool = /* GraphQL */ `
  subscription OnCreateDocumentPool {
    onCreateDocumentPool {
      id
      associationId
      title
      content
      type
      createdAt
      updatedAt
      owner
      files(limit: 50) {
        items {
          id
          file {
            bucket
            region
            key
          }
          parentId
          title
          createdAt
        }
      }
    }
  }
`
export const onUpdateDocument = /* GraphQL */ `
  subscription OnUpdateDocument {
    onUpdateDocument {
      id
      associationId
      title
      content
      type
      createdAt
      updatedAt
      owner
      files {
        items {
          id
          file {
            bucket
            region
            key
          }
          title
          createdAt
        }
        nextToken
      }
    }
  }
`
export const onDeleteDocument = /* GraphQL */ `
  subscription OnDeleteDocument {
    onDeleteDocument {
      id
      associationId
      title
      content
      type
      createdAt
      updatedAt
      owner
      files {
        items {
          id
          file {
            bucket
            region
            key
          }
          title
          createdAt
        }
        nextToken
      }
    }
  }
`
export const onCreateFile = /* GraphQL */ `
  subscription OnCreateFile {
    onCreateFile {
      id
      associationId
      file {
        bucket
        region
        key
      }
      parentId
      title
      createdAt
      updatedAt
      owner
    }
  }
`
export const onUpdateFile = /* GraphQL */ `
  subscription OnUpdateFile {
    onUpdateFile {
      id
      associationId
      file {
        bucket
        region
        key
      }
      parentId
      title
      createdAt
      updatedAt
      owner
    }
  }
`
export const onDeleteFile = /* GraphQL */ `
  subscription OnDeleteFile {
    onDeleteFile {
      id
      associationId
      file {
        bucket
        region
        key
      }
      parentId
      title
      createdAt
      updatedAt
      owner
    }
  }
`
export const onCreateMessage = /* GraphQL */ `
  subscription OnCreateMessage {
    onCreateMessage {
      id
      associationId
      content
      createdAt
      author {
        id
        firstName
        lastName
        email
        phone
        avatar {
          bucket
          region
          key
        }
      }
      files {
        items {
          id
          file {
            bucket
            region
            key
          }
          createdAt
        }
        nextToken
      }
    }
  }
`
export const onCreateMessagePool = /* GraphQL */ `
  subscription OnCreateMessagePool {
    onCreateMessagePool {
      id
      associationId
      content
      createdAt
      author {
        id
        firstName
        lastName
        email
        phone
        avatar {
          bucket
          region
          key
        }
      }
      files {
        items {
          id
          file {
            bucket
            region
            key
          }
          createdAt
        }
        nextToken
      }
    }
  }
`
export const onUpdateMessage = /* GraphQL */ `
  subscription OnUpdateMessage {
    onUpdateMessage {
      id
      associationId
      content
      createdAt
      owner
      author {
        id
        firstName
        lastName
        email
        phone
        avatar {
          bucket
          region
          key
        }
      }
    }
  }
`
export const onDeleteMessage = /* GraphQL */ `
  subscription OnDeleteMessage {
    onDeleteMessage {
      id
      associationId
      content
      createdAt
      owner
      author {
        id
        firstName
        lastName
        email
        phone
        avatar {
          bucket
          region
          key
        }
      }
    }
  }
`
export const onCreateInvite = /* GraphQL */ `
  subscription OnCreateInvite {
    onCreateInvite {
      id
      email
      role
      author {
        id
        firstName
        lastName
        email
        phone
        avatar {
          bucket
          region
          key
        }
        createdAt
      }
      createdAt
      association {
        id
        name
      }
    }
  }
`
export const onCreateDisclosure = /* GraphQL */ `
  subscription OnCreateDisclosure($owner: String) {
    onCreateDisclosure(owner: $owner) {
      id
      associationId
      unit
      haveLiens
      liensDescription
      reservesAmount
      haveCapitalExpenditures
      capitalExpendituresType
      capitalExpendituresOther
      haveSpecialAssessment
      specialAssessmentAmount
      haveIncreaseMonthly
      increaseMonthlyAmount
      increaseMonthlyEndDate
      haveCompliantAlterations
      compliantAlterationsDescription
      haveLawsuits
      lawsuitsDescription
      insuranceName
      insuranceAddress
      insuranceContactName
      insurancePhone
      insuranceEmail
      asssessmentAmount
      unpaidAssessmentAmount
      contactEmail
      preparedByName
      preparedDate
      createdAt
      updatedAt
      latestFinancials {
        id
        associationId
        title
        content
        type
        createdAt
        updatedAt
        owner
        files {
          nextToken
        }
      }
      latestBudget {
        id
        associationId
        title
        content
        type
        createdAt
        updatedAt
        owner
        files {
          nextToken
        }
      }
      latestMinutes {
        id
        associationId
        title
        content
        type
        createdAt
        updatedAt
        owner
        files {
          nextToken
        }
      }
      owner
    }
  }
`
export const onUpdateDisclosure = /* GraphQL */ `
  subscription OnUpdateDisclosure($owner: String) {
    onUpdateDisclosure(owner: $owner) {
      id
      associationId
      unit
      haveLiens
      liensDescription
      reservesAmount
      haveCapitalExpenditures
      capitalExpendituresType
      capitalExpendituresOther
      haveSpecialAssessment
      specialAssessmentAmount
      haveIncreaseMonthly
      increaseMonthlyAmount
      increaseMonthlyEndDate
      haveCompliantAlterations
      compliantAlterationsDescription
      haveLawsuits
      lawsuitsDescription
      insuranceName
      insuranceAddress
      insuranceContactName
      insurancePhone
      insuranceEmail
      asssessmentAmount
      unpaidAssessmentAmount
      contactEmail
      preparedByName
      preparedDate
      createdAt
      updatedAt
      latestFinancials {
        id
        associationId
        title
        content
        type
        createdAt
        updatedAt
        owner
        files {
          nextToken
        }
      }
      latestBudget {
        id
        associationId
        title
        content
        type
        createdAt
        updatedAt
        owner
        files {
          nextToken
        }
      }
      latestMinutes {
        id
        associationId
        title
        content
        type
        createdAt
        updatedAt
        owner
        files {
          nextToken
        }
      }
      owner
    }
  }
`
export const onDeleteDisclosure = /* GraphQL */ `
  subscription OnDeleteDisclosure($owner: String) {
    onDeleteDisclosure(owner: $owner) {
      id
      associationId
      unit
      haveLiens
      liensDescription
      reservesAmount
      haveCapitalExpenditures
      capitalExpendituresType
      capitalExpendituresOther
      haveSpecialAssessment
      specialAssessmentAmount
      haveIncreaseMonthly
      increaseMonthlyAmount
      increaseMonthlyEndDate
      haveCompliantAlterations
      compliantAlterationsDescription
      haveLawsuits
      lawsuitsDescription
      insuranceName
      insuranceAddress
      insuranceContactName
      insurancePhone
      insuranceEmail
      asssessmentAmount
      unpaidAssessmentAmount
      contactEmail
      preparedByName
      preparedDate
      createdAt
      updatedAt
      latestFinancials {
        id
        associationId
        title
        content
        type
        createdAt
        updatedAt
        owner
        files {
          nextToken
        }
      }
      latestBudget {
        id
        associationId
        title
        content
        type
        createdAt
        updatedAt
        owner
        files {
          nextToken
        }
      }
      latestMinutes {
        id
        associationId
        title
        content
        type
        createdAt
        updatedAt
        owner
        files {
          nextToken
        }
      }
      owner
    }
  }
`
